const App = () =>
    import ('@/layout/AppMeeting.vue')
const Login = () =>
    import ('@/views/login/login.vue')
const LoginWorker = () =>
    import ('@/views/login/loginWorker.vue')
const ForgetPassword = () =>
    import ('@/views/login/forgetPassword.vue')
const ResetPassword = () =>
    import ('@/views/login/resetPassword.vue')
const Logininvite = () =>
    import ('@/views/login/logininvite.vue')
const agreement = () =>
    import ('@/views/login/agreement.vue')
const adjudgment = () =>
    import ('@/views/login/adjudgment.vue')

export default {
    path: '/',
    component: App,
    redirect: '/login',
    sort: 1,
    children: [{
            path: '/login',
            component: Login
        },
        {
            path: '/loginWorker',
            component: LoginWorker
        },
        {
            path: '/forgetPassword',
            component: ForgetPassword
        },
        {
            path: '/resetPassword',
            component: ResetPassword
        },
        {
            path: '/logininvite',
            component: Logininvite
        },
        {
            path: '/agreement',
            component: agreement
        },
        {
            path: '/adjudgment',
            component: adjudgment
        }
    ]
}